import AppHeader from "../../layout/AppHeader";
import ObjectSro from '../../xpost/views/services/objects.sro/ObjectSro.vue';
import SearchCep from '../../xpost/views/services/search.cep/SearchCep.vue';
import SystemLog from '../../xpost/views/services/system.log/SystemLog.vue';
import NotificationLog from '../../xpost/views/services/system.log/NotificationLog.vue';
import Workarea from '../../views/Workarea.vue';

const SearchOptionsRoutes = [
  {
    path: "/pesquisa/objetossro",
    name: "objects.sro",
    components: {
      header: AppHeader,
      default: ObjectSro,
    }
  },
  {
    path: "/pesquisa/painelprepostagem",
    name: "prepost.panel",
    components: {
      header: AppHeader,
      default: Workarea,
    }
  },
  {
    path: "/pesquisa/objetossro/:tag",
    name: "objects.sro.tag",
    meta: {
      public: true
    },
    components: {
      header: AppHeader,
      default: ObjectSro,
    }
  },
  {
    path: "/pesquisa/cep",
    name: "search.cep",
    components: {
      header: AppHeader,
      default: SearchCep,
    }
  },
  {
    path: "/pesquisa/logsistema",
    name: "system.log",
    components: {
      header: AppHeader,
      default: SystemLog,
    }
  },
  {
    path: "/pesquisa/notificacao",
    name: "notification.log",
    components: {
      header: AppHeader,
      default: NotificationLog,
    }
  },
]

export default SearchOptionsRoutes;